import { TenantDTOAdditionalFeaturesEnum } from 'probonio-shared-ui/api';
import { useTenant } from 'probonio-shared-ui/module/me';

/** whether the tenant may filter its employee list by origin (Probonio vs Bikeleasing) */
export function useSourceFilterEnabled(): boolean {
  const { tenant } = useTenant();
  return tenant?.additionalFeatures?.includes(TenantDTOAdditionalFeaturesEnum.SourceFilter) ?? false;
}
